import { ActivityIndicator } from 'react-native'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { Colors, Metrics } from 'APP/Themes'

export const RetryCtaStyle = {
  marginTop: Metrics.baseMargin * 2,
  minWidth: 140,
}

export const HeaderContainer = styled.View`
  flex-direction: row;
  justify-content: center;
`

export const Header = styled(Typography)`
  flex: 0.8;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const Loading = styled(ActivityIndicator)`
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin * 8}px;
`

export const RetryContainer = styled.View`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 4}px;
`

export const RetryTitle = styled(Typography)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const Subheading = styled(Typography)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const IllustrationImage = styled.Image<{ alignRight?: boolean }>`
  position: absolute;
  top: 0;
  height: 240px;
  width: 120px;
  resize-mode: contain;
  ${({ alignRight }) => alignRight && 'right: 0;'}
`

export const ProgressWrapper = styled.View`
  display: flex;
  align-items: center;
`

export const ProgressFraction = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const ProgressValue = styled(Typography)<{ achieved?: boolean }>`
  color: ${({ theme, achieved }) =>
    achieved ? Colors.accessiblePeppermintText : theme.colors.accent};
`

export const ProgressCopy = styled(Typography)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
`
